import { Component, Vue, Mixins } from 'vue-property-decorator';
import { AllComponents } from '@/components/AllComponents';
import CommonView from '@/views/CommonView';
import SBAPI from '@/util/SBAPI';
import { AxiosErrorHandler, isAxiosError } from '@/util/AxiosErrorHandler';
import SBSection from '@/components/SBSection.vue';
import SBKurukuru from '@/components/SBKurukuru.vue';
import SBSubTitle from '@/components/SBSubTitle.vue';
import SBText from '@/components/SBText.vue';
import SBSignUpForm from '@/components/SBSignUpForm.vue';
import SBTextbox from '@/components/SBTextbox.vue';
import SBNextBack from '@/components/SBNextBack.vue';
import SBButtonSmallGray from '@/components/SBButtonSmallGray.vue';
import SBButtonSmall from '@/components/SBButtonSmall.vue';

@Component({
    components: {
        SBSection,
        SBButtonSmallGray,
        SBKurukuru,
        SBSubTitle,
        SBText,
        SBSignUpForm,
        SBTextbox,
        SBNextBack,
        SBButtonSmall,
    }
})
export default class Password extends Mixins(CommonView) {
    mode: number = 0;
    kurukuru: boolean = false;
    error: string = "";
    password: string = "";
    passConfirmation: string = "";

    public async created() {
        if (await this.isLoginRedirect(true)) return;
    }

    public async post() {
        this.kurukuru = true;

        if (!this.password) {
            this.kurukuru = false;
            return;
        }
        if (this.passConfirmation != this.password) {
            this.kurukuru = false;
            this.error = "パスワードが一致しません。";
            return;
        }

        let profile = await SBAPI.UserController.getUserUsingGET().catch(AxiosErrorHandler);
        if (isAxiosError(profile)) {
            this.error = "" + profile.data;
            return;
        }
        let user = profile.data;
        user.password = this.password;
        let res = await SBAPI.UserController.putUserUsingPUT(user).catch(AxiosErrorHandler);
        if (isAxiosError(res)) {
            this.error = "" + res.data;
        } else {
            this.mode = 1;
        }
        this.kurukuru = false;
    }
}
